import { apiClient } from './axios';

import type {
  ConfigurationSetup,
  CreateConfigurationSetupDto,
  UpdateConfigurationSetupDto,
  CreateConfigurationVersionDto,
  ConfigurationVersion,
} from '@repo/shared-types';

export const configurationsApi = {
  getConfigurations: async () => {
    const response = await apiClient.get<ConfigurationSetup[]>('/configurations');
    return response.data;
  },

  getConfiguration: async (id: string) => {
    const response = await apiClient.get<ConfigurationSetup>(`/configurations/${id}`);
    return response.data;
  },

  createConfiguration: async (data: CreateConfigurationSetupDto) => {
    const response = await apiClient.post<ConfigurationSetup>('/configurations', data);
    return response.data;
  },

  updateConfiguration: async (id: string, data: UpdateConfigurationSetupDto) => {
    const response = await apiClient.patch<ConfigurationSetup>(`/configurations/${id}`, data);
    return response.data;
  },

  deleteConfiguration: async (id: string) => {
    await apiClient.delete(`/configurations/${id}`);
  },

  testConfiguration: async (id: string, phoneNumber: string) => {
    const response = await apiClient.post<{ callSid: string; message: string }>(
      `/configurations/${id}/test-call`,
      { phoneNumber },
    );
    return response.data;
  },

  testConfigurationWebcall: async (id: string) => {
    // Returns a stateless connection ticket; callId/callSid arrive over the
    // WebSocket ('ready' / 'call_materialized') once the session is created.
    const response = await apiClient.post<{
      wsToken: string;
      wsPath: string;
      message: string;
    }>(`/configurations/${id}/test-webcall`);
    return response.data;
  },

  createVersion: async (configId: string, data: CreateConfigurationVersionDto) => {
    const response = await apiClient.post<ConfigurationVersion>(
      `/configurations/${configId}/versions`,
      data,
    );
    return response.data;
  },

  setActiveVersion: async (configId: string, versionId: string) => {
    const response = await apiClient.post<ConfigurationSetup>(
      `/configurations/${configId}/versions/${versionId}/activate`,
    );
    return response.data;
  },

  deleteVersion: async (configId: string, versionId: string) => {
    await apiClient.delete(`/configurations/${configId}/versions/${versionId}`);
  },

  getVersionCallCount: async (configId: string, versionId: string) => {
    const response = await apiClient.get<number>(
      `/configurations/${configId}/versions/${versionId}/calls/count`,
    );
    return response.data;
  },
};
